var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragNDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 67,
    viewBox: "0 0 71 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2493 24.7437V21.1531C17.2493 11.238 25.2871 3.2002 35.2021 3.2002C45.1172 3.2002 53.155 11.238 53.155 21.1531V24.7437C61.087 24.7437 67.5173 31.174 67.5173 39.106C67.5173 44.4222 64.6291 49.1897 60.3362 51.673M17.2493 24.7437C9.31718 24.7437 2.88696 31.174 2.88696 39.106C2.88696 44.4222 5.77522 49.1897 10.0681 51.673M17.2493 24.7437C18.8034 24.7437 20.3 24.9907 21.7018 25.447M35.2021 31.9248V64.24M35.2021 31.9248L45.9739 42.6965M35.2021 31.9248L24.4304 42.6965",
    stroke: "#003A9B",
    strokeWidth: 5.38586,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragNDropIcon);
export default __webpack_public_path__ + "static/media/drag-n-drop-icon.60c904c38462354e11a132e830ebc6f8.svg";
export { ForwardRef as ReactComponent };